var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnits(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.45,9.96L10.02,39.48l-9.87-9.84L29.58,0.12L39.45,9.96z M10.02,36.95l26.9-26.99l-7.33-7.31L2.69,29.64 L10.02,36.95z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.07,
    y: 30.87,
    transform: "matrix(0.7059 -0.7083 0.7083 0.7059 -19.8862 18.1931)",
    className: "st0",
    width: 1.79,
    height: 4.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.71,
    y: 23.64,
    transform: "matrix(0.7059 -0.7083 0.7083 0.7059 -15.2478 18.4632)",
    className: "st0",
    width: 1.79,
    height: 7.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.23,
    y: 22.69,
    transform: "matrix(0.7059 -0.7083 0.7083 0.7059 -11.6918 21.5634)",
    className: "st0",
    width: 1.79,
    height: 4.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.87,
    y: 15.46,
    transform: "matrix(0.7059 -0.7083 0.7083 0.7059 -7.0532 21.8337)",
    className: "st0",
    width: 1.79,
    height: 7.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.66,
    y: 14.23,
    transform: "matrix(0.7059 -0.7083 0.7083 0.7059 -3.217 25.0492)",
    className: "st0",
    width: 1.79,
    height: 4.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.31,
    y: 7,
    transform: "matrix(0.7059 -0.7083 0.7083 0.7059 1.421 25.3192)",
    className: "st0",
    width: 1.79,
    height: 7.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnits);
export default __webpack_public_path__ + "static/media/units.645bc7cdba0533747ce0a0dfa99e889d.svg";
export { ForwardRef as ReactComponent };